var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "welfareCenter", staticClass: "welfare-center-wrap" },
    [
      _c("div", { staticClass: "top" }, [
        _c("div", { staticClass: "back" }, [
          _c("div", {
            staticClass: "icon",
            on: {
              click: function ($event) {
                return _vm.$emit("close")
              },
            },
          }),
          _c("div", { staticClass: "txt" }, [
            _vm._v(_vm._s(_vm.$t("boon-page-title"))),
          ]),
        ]),
        _c("div", { staticClass: "close" }, [
          _c("div", {
            staticClass: "icon",
            on: {
              click: function ($event) {
                return _vm.$emit("close")
              },
            },
          }),
        ]),
      ]),
      _c("div", { staticClass: "welfare-content" }, [
        _c("div", { staticClass: "menu-wrap" }, [
          _c(
            "div",
            { staticClass: "menu-list" },
            [
              _vm._l(_vm.CONFIG, function (item, index) {
                return [
                  _c("div", { key: `_${index}`, staticClass: "divider" }),
                  _c(
                    "div",
                    {
                      key: index,
                      staticClass: "menu-items",
                      class: {
                        active: item.key === _vm.crtKey,
                        first: index === 0,
                      },
                      on: {
                        click: function ($event) {
                          _vm.crtKey = item.key
                        },
                      },
                    },
                    [
                      item.dot ? _c("div", { staticClass: "dot" }) : _vm._e(),
                      _vm._v(" " + _vm._s(_vm.$t(item.key)) + " "),
                    ]
                  ),
                ]
              }),
              _c("div", { staticClass: "divider" }),
            ],
            2
          ),
        ]),
        _c(
          "div",
          { staticClass: "body" },
          [
            _vm._l(_vm.CONFIG, function (item, index) {
              return [
                _c(item.comp, {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: item.key === _vm.crtKey,
                      expression: "item.key === crtKey",
                    },
                  ],
                  key: index,
                  tag: "component",
                  attrs: { "is-show": item.key === _vm.crtKey },
                  on: { setDot: (_) => _vm.setDot(index, _) },
                }),
              ]
            }),
          ],
          2
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }